var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.42,
    height: 15.229,
    viewBox: "0 0 10.42 15.229",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Location1",
    transform: "translate(-760.168 -301.999)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "pin_drop_24dp_E8EAED_FILL0_wght300_GRAD0_opsz24_1_",
    "data-name": "pin_drop_24dp_E8EAED_FILL0_wght300_GRAD0_opsz24 (1)",
    d: "M225.21-848.6a15.373,15.373,0,0,0,2.992-3.217,5.382,5.382,0,0,0,1.016-2.909,4.008,4.008,0,0,0-1.122-2.931,3.868,3.868,0,0,0-2.885-1.143,3.868,3.868,0,0,0-2.885,1.143,4.008,4.008,0,0,0-1.122,2.931,5.382,5.382,0,0,0,1.016,2.909A15.373,15.373,0,0,0,225.21-848.6Zm0,1.523a17.938,17.938,0,0,1-3.906-3.936,6.638,6.638,0,0,1-1.3-3.712,5.189,5.189,0,0,1,1.455-3.794A5.032,5.032,0,0,1,225.21-860a5.032,5.032,0,0,1,3.755,1.482,5.189,5.189,0,0,1,1.455,3.794,6.62,6.62,0,0,1-1.3,3.708A18.108,18.108,0,0,1,225.21-847.076Zm0-6.266a1.4,1.4,0,0,0,1.024-.425,1.4,1.4,0,0,0,.425-1.024,1.4,1.4,0,0,0-.425-1.024,1.4,1.4,0,0,0-1.024-.425,1.4,1.4,0,0,0-1.024.425,1.4,1.4,0,0,0-.425,1.024,1.4,1.4,0,0,0,.425,1.024A1.4,1.4,0,0,0,225.21-853.341Zm-5.21,8.57v-1.2h10.42v1.2ZM225.21-854.79Z",
    transform: "translate(540.168 1161.999)",
    fill: "#015ca3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/location_icon.25e7cdd92e0b41f9526fb20fb0b9b7f9.svg";
export { ForwardRef as ReactComponent };